var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebSuccessOtp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_3681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.902 57.064L102.782 42.4966L104.836 22.9946L85.6503 18.9328L75.8636 1.9317L57.9513 9.93693L40.0391 1.9317L30.2524 18.9328L11.0666 22.9946L13.1207 42.4966L0 57.064L13.1205 71.6314L11.0663 91.1334L30.2522 95.1951L40.0388 112.196L57.9511 104.191L75.8634 112.196L85.6501 95.1951L104.836 91.1334L102.782 71.6314L115.902 57.064Z",
    fill: "#1E56FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6343 56.8296L50.9489 69.5414L73.405 46.361",
    stroke: "white",
    strokeWidth: 5.79512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_3681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.902,
    height: 115.902,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSuccessOtp);
export default __webpack_public_path__ + "static/media/web-success-otp.f0f81e9e53ec2dff7e351621578ea05d.svg";
export { ForwardRef as ReactComponent };